import styled, { css } from 'styled-components';

import { GatsbyLink } from 'components/Links';

export { LinkHighlight } from 'components/Navigation/Menu/Link.styled';

// NOTE: This is just a slightly different styling of `../Menu/Link.styled`
export const Link = styled(GatsbyLink)<{ bold?: boolean; corePage?: boolean }>`
  color: inherit;

  font-size: ${props => props.theme.fontSize.xxs};
  font-weight: ${props => props.theme.fontWeight.normal};
  line-height: ${props => props.theme.lineHeight.sm};
  height: ${props => props.theme.lineHeight.sm};
  display: block;
  text-decoration: underline;
  opacity: 0.85;
  transition: 250ms opacity;

  ${({ bold, corePage, theme }) =>
    (bold || corePage) &&
    css`
      font-weight: ${theme.fontWeight.bold};
    `}
  &:hover,
  &:focus,
  &:focus-within {
    opacity: 1;
  }
`;
